<div class="p-3">
  <app-wizard-head [wizardInput]="wizardInput"></app-wizard-head>
</div>
<letter-generation-library *ngIf="isDataLoaded" [primaryData]="inputData" style="width:100%" [simplifyH1b]="true"
  [isWizard]="true"></letter-generation-library>